export default "__VITE_ASSET__Bril0QP5__"